<template>
  <v-container>
  <v-card>

      <DetallesApelacion
        v-if="cuenta_detalles"
        :cuenta="cuenta_detalles"
        :apelacion="apelacion"
        :role="roleUser"
        @closeModal="$router.push({ name:'Tocas' })"
      >
      </DetallesApelacion>

      <NewObservacion
        v-if="cuenta_detalles && (currentUser.id === cuenta_detalles.relator_id || currentUser.id === cuenta_detalles.magistrado_id)"
        :item="cuenta_detalles"
        :role="roleUser"
      >
      </NewObservacion>

      <Sentido
        v-if="cuenta_detalles && (roleUser == 'magistrado') "
        :cuenta="cuenta_detalles"
        :apelacion="apelacion"
        :role="roleUser"
      >
      </Sentido>

      <ColegiadaVotos
        v-if="cuenta_detalles && roleUser == 'magistrado'"
        :item="cuenta_detalles"
        :role="roleUser"
      >
      </ColegiadaVotos>

      <ObservacionColegiada
        v-if="cuenta_detalles && roleUser == 'magistrado'"
        :item="cuenta_detalles"
        :role="roleUser"
      >
      </ObservacionColegiada>

      <!-- <SubirResolucion
        v-if="cuenta_detalles && (roleUser == 'magistrado' || roleUser == 'relator')" -->
      <SubirResolucion
        v-if="cuenta_detalles && cuenta_detalles.status <= 44 && (currentUser.id === cuenta_detalles.relator_id  || currentUser.id === cuenta_detalles.magistrado_id)"
        :item="cuenta_detalles"
        :apelacion="apelacion"
        :role="roleUser"
        @updateCuenta="updateCuenta($event)"
      >
      </SubirResolucion>
      <ListDocumentos
        v-if="cuenta_detalles && (roleUser == 'magistrado' || roleUser == 'relator')"
        ref="documentos"
        :cuenta="cuenta_detalles"
        :apelacion="apelacion"
        :role="roleUser"
      >
      </ListDocumentos>
      <Archivar
        v-if="cuenta_detalles && (roleUser == 'magistrado' || roleUser == 'relator')"
        :cuenta="cuenta_detalles"
        :apelacion="apelacion"
        :role="roleUser"
        @closeModal="$router.push({ name:'Tocas' })"
      >
      </Archivar>
    </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  // import { VueEditor } from 'vue2-editor';
  import DetallesApelacion from "../../components/DetallesApelacion";
  import NewObservacion from "../../components/NewObservacion";
  import Sentido from "../../components/Sentido";
  import SubirResolucion from "@/components/SubirResolucion";
  import ListDocumentos from "@/components/ListDocumentos";
  import Archivar from "@/components/Archivar";
  import ColegiadaVotos from "@/components/ColegiadaVotos";
  import ObservacionColegiada from "../../components/ObservacionColegiada.vue";

  export default {
    components: {
    DetallesApelacion,
    NewObservacion,
    Sentido,
    SubirResolucion,
    ListDocumentos,
    Archivar,
    ColegiadaVotos,
    ObservacionColegiada
},
    props: {
      source: String
    },
    data(){
      return{
        apelacion: null,
        cuenta_detalles: null,
        cuenta: {},
      }
    },
    computed: {
      formTitle () {
        return 'Add Observación'
      },
      ...mapGetters(["currentUser", "roleUser", "currentCuenta"]),
    },
    mounted() {
      this.cuenta_id = JSON.parse(localStorage.getItem("currentCuenta"))
      this.getCuenta()
    },
    methods:{
      getCuenta(){
        this.$store.dispatch("SHOW_CUENTA", {
          url:"/cuenta/"+ this.cuenta_id
        }).then((response) => {
          this.cuenta_detalles = response.data.data.cuenta
          this.apelacion = response.data.data.cuenta.apelacion
        }).catch(err => {
          console.log(err);
        });
      },
      updateCuenta (val){
        // this.getCuenta()
        this.cuenta_detalles.resolucion_proyecto = val
        this.$refs.documentos.getDocs();
      }
    }
  }
</script>

<style media="screen">
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgb(62 61 61 / 87%);
  }
  .table {
    border-collapse:collapse;
    width: 100%;
  }

  .format_table {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
</style>
